export default __webpack_public_path__ + "static/practical-5357fe69ebffbff26c98d18e302e47bc.jpg";